<template>

    <m-edit1/>

    <m-coming-soon-1 v-bind='{...{"countDownText":"roshdfarm","mainText":"roshdfarm","contactUsHref":"https:\/\/mixitweb.com","backgroundImage":"https:\/\/picsum.photos\/1280\/720","counterMonth":10,"counterDay":10,"counterYear":2026},...{}}' :style='""' class="" ></m-coming-soon-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mComingSoon1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Message/ComingSoon/ComingSoon1';

export default {
    name: 'HomeView',
    components: {mEdit1, mComingSoon1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
